import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c81db77e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c81db77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81db77e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81db77e')) {
      api.createRecord('c81db77e', component.options)
    } else {
      api.reload('c81db77e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c81db77e&scoped=true&", function () {
      api.rerender('c81db77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/DocBox.vue"
export default component.exports